import { IMessageData, TMessageName } from './interfaces';
import messages from './messages';

/**
 * Insert data into template
 */
function injectData(template: string, data: IMessageData, keyPrefix = '') {
  Object.keys(data).forEach((key) => {
    let tplKey = keyPrefix ? `${ keyPrefix }.${ key }` : `${ key }`;
    if (typeof data[key] === 'object' && data[key] !== null) {
      injectData(template, data[key], tplKey);
    }

    template = template.replace(`{{${ tplKey }}}`, data[key]);
  });

  template = template.replace('{{callback_params}}', encodeURIComponent(JSON.stringify(data)));

  return template;
}

/**
 * Get message from code with rendered data
 * @deprecated Shouldn't be used directly, use `MessageService.getMessageByErrorCode` instead.
 */
// @ts-ignore TODO: FIN-32798 strictNullChecks
function getMessage(name: TMessageName, data: IMessageData = undefined) {
  let messageText = messages[name] || messages.GENERAL_ERROR;

  if (data) {
    messageText = injectData(messageText, data);
  }

  return messageText;
}

export default getMessage;
